import { getOwner } from "@ember/application"
import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { Promise } from "rsvp"
import jwtDecode from "../../lib/jwt-decode"

export default class EditPasswordRoute extends Route {
  @service
  finder

  @service("ember-store")
  store

  @service
  session

  @service
  rpc

  model(params) {
    /**
    I should probably just do this in the background?
    I should put the app into the loading state while I fetch a link?

    That way, if I send a link with a token in it, like for an email,
    I do the same thing -- I request an official token from
    the client. So, in that way, sending a PW reset email is the same
    as sending a check your comment email -- it's just an email.

    We could also do the check into localStorage to see if we stored it there
    and, if so, not request one from the server. Otherwise, request a new
    token.

    So, flow:
    - send token to server
    - 200
      - set new session token, continue
    - 401
      - show error message that token is expired and have them send a new token
    - _
      - show generic error message


    For the application,
    - send token to server
    - 200
      - set new session token, continue
    - 401
      - send to the login page
      - on login, check if there was a URL to go to.
      - This is where it gets tricky -- maybe we just send them to the page anyways?
        and have a sign in modal that's really easy to use? I'd be for that.




    */

    if (params.resetPasswordToken) {
      return new Promise((resolve, reject) => {
        get(this, "rpc")
          .execute("EXCHANGE_TOKEN", get(this, "session.id"), params.resetPasswordToken)
          .then((result) => {
            this.finder.insertResponseDocs(result, getOwner(this).lookup("adapter:user"), "user", [
              this.session.userId,
            ])
            this.session.setTokenAndAuthenticate(result.data)
            // this.transitionTo({queryParams: {resetPasswordToken: null, completed: false}})
            return resolve(result)
          })
          .catch((error) => {
            console.log("error", error)
            let err = error && error.errors ? error.errors[0] : null
            return reject(err)
          })
      })
      /**
        - Ajax to server
        - 200
          - log in user
        - 401
          - redirect to edit-password-error.js

       */
    }

    // return this.transitionTo('user.edit-password.error')
    // return new Error("Expired")
    // throw "Expired"

    if (params.resetPasswordToken) {
      // Check if expired
      let decodedJwt = jwtDecode(params.resetPasswordToken)
      get(this, "store").insertDocument({
        id: decodedJwt.sessionId,
        type: "session",
        attributes: {
          token: params.resetPasswordToken,
        },
      })
      get(this, "session").set("sessionId", decodedJwt.sessionId)
    } else {
      this.transitionTo("user.sign")
    }
  }
}
